import React, { useEffect, useState } from "react";
import { Box, Button, Grid, Typography, useTheme, useMediaQuery } from "@mui/material";
import tickImage from "../../assets/images/tick.png";
import SecondaryButton from "../../common/secondaryButton";
import SubmitModal from "../liveTest/submitModal";
import { useDispatch, useSelector } from "react-redux";
import commonActions from "../../Redux/common/actions";
import { useNavigate, useSearchParams } from "react-router-dom";
import Cookies from "js-cookie";
import { handleEncodeJson } from "../../utils/encodeDecodeJson";
import examActions from "../../Redux/exam/actions";
import dayjs from "dayjs";
import { MdChevronLeft, MdChevronRight } from "react-icons/md";
import utc from "dayjs/plugin/utc";
import duration from "dayjs/plugin/duration";
import isSameOrAfter from "dayjs/plugin/isSameOrAfter";
import {
  DecryptObjectFunction,
  EncryptObjectFunction,
} from "../../utils/cryptoFunction";
import checkAuth from "../../common/CheckAuth";
import useFetchQuestion from "../../hooks/useFetchQuestion";
import useFetchCandidateTokenDetails from "../../hooks/useFetchCandidateTokenDetails";
import { auditLog } from "../../utils/auditLog";
import { ensureFullscreen } from '../../utils/fullScreenHelper';
dayjs.extend(utc);
dayjs.extend(duration);
dayjs.extend(isSameOrAfter);

export default function Index() {
  const theme = useTheme();
  const isMobile = useMediaQuery(theme.breakpoints.down("sm"));

  const dispatch = useDispatch();
  const navigate = useNavigate();
  const { questionsAndOptions, projectDetails, heartBeat } = useSelector(
    (state) => state.examReducer
  );
  const [questionNumber, setQuestionNumber] = useState([]);
  const [desktopCollapsed, setDesktopCollapsed] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [candidateTokenDetails, setCandidateTokenDetails] = useState(null);
  const [visitedQuestions, setVisitedQuestions] = useState(new Set());
  const [close, setClose] = useState(isMobile)
  const isVenue = sessionStorage.getItem("venue") ?? false;
  const apiUrl = sessionStorage.getItem("apiUrl");
  const [searchParams] = useSearchParams();
  const encryptParams = searchParams.get("qNo");
  let isMock = projectDetails?.mockMode;


  const handleClose = () => {
    setClose(!close)
  }

  let decryptParams = {};
  if (encryptParams) {
    try {
      decryptParams = DecryptObjectFunction(encryptParams);
    } catch (error) {
      console.error("Error decrypting parameters:", error);
      decryptParams = {};
    }
  } else {
    console.warn("No query parameter 'qNo' found.");
  }

  const [data, setData] = useState({});

  let isAutologout = candidateTokenDetails?.configuration?.autoLogout;
  const isLateLoginAllowed =
    candidateTokenDetails?.configuration?.lateLoginAllowed;
  const isForceLogout = candidateTokenDetails?.configuration?.forceLogout;

  const examEndTime = localStorage.getItem("examEndTime");
  const examEndDate = new Date(examEndTime);
  examEndDate.setTime(examEndDate.getTime() + (5 * 60 + 30) * 60 * 1000);
  const updatedExamEndTime = examEndDate.toISOString();
  const now = new Date(heartBeat?.data);
  const isSection = Object.values(
    questionsAndOptions?.questionsList || {}
  ).every((res) => "section" in res);
  const isStartExamBetweenSpecifiedTime =
    candidateTokenDetails?.configuration?.startExamBetweenSpecifiedTime;
  const isMultidayExamWithSection =
    isSection && isStartExamBetweenSpecifiedTime;
  const isMaximumLoginAttempts =
    candidateTokenDetails?.configuration?.maximumLoginAttempts === null;

  // const endTime = new Date(
  //   // (isLateLoginAllowed && isMaximumLoginAttempts) ||
  //   // (isMultidayExamWithSection && isMaximumLoginAttempts)
  //   //   ? candidateTokenDetails?.configuration?.endTime
  //   //   :
  //   isForceLogout
  //   ? candidateTokenDetails?.configuration?.endTime
  //   : updatedExamEndTime ?? candidateTokenDetails?.configuration?.endTime
  // );

  const endTime = new Date(
    isForceLogout
      ? candidateTokenDetails?.configuration?.endTime
      : updatedExamEndTime ?? candidateTokenDetails?.configuration?.endTime
  );

  const isExamEnded = now > endTime;
  useEffect(() => {
    if (!checkAuth(navigate)) return;
  }, []);

  useEffect(() => {
    const numArray = Array.from({ length: 70 }, (_, i) => i + 1);
    setQuestionNumber(numArray);
  }, []);

  useEffect(() => {
    if (isMobile) {
      setClose(true);   // mobile: closed by default
    }
  }, [isMobile]);

  const toggleDesktop = () => {
    setDesktopCollapsed(prev => !prev);
  };

  const openMobileSummary = () => {
    setMobileOpen(true);
  };

  const closeMobileSummary = () => {
    setMobileOpen(false);
  };

  useEffect(() => {
    const storedVisited = sessionStorage.getItem("visitedQuestions");
    if (storedVisited) {
      setVisitedQuestions(new Set(JSON.parse(storedVisited)));
    }
  }, [visitedQuestions]);

  const handleSubmit = () => {
    dispatch({
      type: commonActions.SET_SHOW_MODAL,
      payload: { show: true, type: "confirm", method: "S", data: null },
    });
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected in Summary Submit",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
  };

  useFetchCandidateTokenDetails({ setCandidateTokenDetails });

  const statusConfigs = [
    {
      key: "answered",
      label: "Answered",
      style: {
        width: "22.82px",
        height: "22.82px",
        background: "rgba(84, 179, 55, 1)",
        clipPath:
          "polygon(25% 0%, 75% 0%, 100% 50%, 100% 100%, 0 100%, 0% 50%)",
      },
    },
    {
      key: "unanswered",
      label: "Unanswered",
      style: {
        width: "22.82px",
        height: "22.82px",
        background: "rgba(234, 104, 58, 1)",
        clipPath: "polygon(0 0, 100% 0, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
      },
    },
    {
      key: "not_viewed",
      label: "Not Viewed",
      style: {
        width: "22.82px",
        height: "22.82px",
        background:
          "linear-gradient(45deg, rgba(240, 239, 240, 1), rgba(201, 200, 201, 1))",
      },
    },
    {
      key: "marked",
      label: "Marked for Review",
      style: {
        width: "22.82px",
        height: "22.82px",
        background: "rgba(130, 91, 172, 1)",
        borderRadius: "50%",
      },
    },
    {
      key: "answered_and_marked",
      label: "Answered & Marked for Review",
      style: {
        width: "22.82px",
        height: "22.82px",
        background: "rgba(130, 91, 172, 1)",
        borderRadius: "50%",
        position: "relative",
      },
    },
  ];

  const getStatusCount = (status) => {
    return Object.values(questionsAndOptions?.questionsList || {}).filter(
      (q) => {
        // const questionNumber = Object.keys(
        //   questionsAndOptions.questionsList
        // ).find((key) => questionsAndOptions.questionsList[key] === q);

        // if (status === "not-viewed") {
        //   return (
        //     !visitedQuestions.has(questionNumber) &&
        //     (q.status.toLowerCase() === "unanswered" || !q.status)
        //   );
        // }

        // if (status === "unanswered") {
        //   return (
        //     visitedQuestions.has(questionNumber) &&
        //     q.status.toLowerCase() === "unanswered"
        //   );
        // }

        return q.status.toLowerCase() === status;
      }
    ).length;
  };

  // useEffect

  const getQuestionStyle = (
    questionStatus,
    isCurrentQuestion,
    questionNumber,
    visitedQuestions
  ) => {
    if (isCurrentQuestion) {
      return {
        background: "#808080",
      };
    }

    if (
      !visitedQuestions.has(questionNumber.toString()) &&
      (questionStatus?.toLowerCase() === "unanswered" || !questionStatus)
    ) {
      return {
        background:
          "linear-gradient(45deg, rgba(240, 239, 240, 1), rgba(201, 200, 201, 1))",
      };
    }

    switch (questionStatus?.toLowerCase()) {
      case "answered":
        return {
          background: "rgba(84, 179, 55, 1)",
          clipPath:
            "polygon(25% 0%, 75% 0%, 100% 50%, 100% 100%, 0 100%, 0% 50%)",
        };
      case "unanswered":
        return {
          background: "rgba(234, 104, 58, 1)",
          clipPath:
            "polygon(0 0, 100% 0, 100% 50%, 75% 100%, 25% 100%, 0% 50%)",
        };
      case "marked":
        return {
          background: "rgba(130, 91, 172, 1)",
          borderRadius: "50%",
        };
      case "answered_and_marked":
        return {
          background: "rgba(130, 91, 172, 1)",
          borderRadius: "50%",
        };
      default:
        return {
          background:
            "linear-gradient(45deg, rgba(240, 239, 240, 1), rgba(201, 200, 201, 1))",
        };
    }
  };

  useEffect(() => {
    if (questionsAndOptions?.questionsList) {
      const groupedData = Object.entries(
        questionsAndOptions.questionsList
      ).reduce((acc, [key, value]) => {
        if (!acc[value.section]) {
          acc[value.section] = [];
        }
        acc[value.section].push({
          question_number: key,
          status: value.status.toLowerCase(),
        });
        return acc;
      }, {});

      setData(groupedData);
    }
  }, [questionsAndOptions?.questionsList]);

  useEffect(() => {
    dispatch({
      type: examActions.GET_PROJECT_DETAILS,
      payload: {
        data: {
          project: `${Cookies.get("test_engine_project")}`,
        },
      },
    });
  }, []);

  const handleResumeExam = async () => {
    auditLog({
      data: {
        RegistrationNumber: `${candidateTokenDetails?.user?.id}`,
        RollNumber: `${candidateTokenDetails?.user?.rollNo}`,
        Activity: "User selected Resume Exam",
        IPaddress: "",
      },
      dispatch,
      heartBeat,
    });
    const formData = {
      imageSize: `${decryptParams?.img}`,
      action: `${decryptParams?.action}` || 'next',
      currentSrNo: decryptParams?.SrNo,
      nextSrNo: decryptParams?.SrNo,
      selectedAnswer: questionsAndOptions?.questionData?.selectedAnswer || 0,
      language: `${decryptParams?.lang}`,
    };
    const encodedData = await handleEncodeJson({ encodeJSON: formData });
    const queryParams = {
      SrNo: decryptParams?.SrNo,
      lang: `${decryptParams?.lang}`,
      img: `${decryptParams?.img}`,
    };
    const encryptParams = EncryptObjectFunction(queryParams);
    if (!encodedData || Object.keys(encodedData).length === 0) {
      if (projectDetails?.mockMode) {
        window.location.href = `/mock?qNo=${encryptParams}`;
        return;
      } else {
        window.location.href = `/${Cookies.get("test_engine_project")}/live-test?qNo=${encryptParams}`;
        return;
      }
    }
    dispatch({
      type: examActions.GET_SUBMIT_ANSWER,
      payload: {
        data: encodedData,
        // navigate: (path) => navigate(`${path}?qNo=${encryptParams}`),
        navigate: (path) => {
          navigate(`${path}?qNo=${encryptParams}`);
        },
        mockMode: projectDetails?.mockMode,
        formData: formData,
        summary: true,
      },
    });
    ensureFullscreen();
  };

  const [countdown, setCountdown] = useState(null);
  const [countdownStarted, setCountdownStarted] = useState(false);

  useEffect(() => {
    const checkTimeAndStartCountdown = () => {
      if (isExamEnded && !countdownStarted) {
        setCountdownStarted(true);
        setCountdown(60);
      }
    };

    const interval = setInterval(checkTimeAndStartCountdown, 1000);
    return () => clearInterval(interval);
  }, [countdownStarted, isExamEnded]);

  useEffect(() => {
    if (countdown === null || countdown <= 0) {
      if (countdown === 0) {
        dispatch({ type: examActions.END_EXAM }) ////////////// for auto submit exam issue ///////////////
        if (isVenue) {
          Cookies.remove("candidate_details");
          Cookies.remove("candidate_exam_details");
          Cookies.remove("test_engine_token");
          sessionStorage.removeItem("examEnded");
          sessionStorage.removeItem("lastUpdatedIndex");
          sessionStorage.removeItem("isEarlyMovedSection");
          navigate(`/login?apiUrl=${apiUrl}`);
        } else {
          Cookies.remove("test_engine_token");
          Cookies.remove("candidate_details");
          Cookies.remove("candidate_exam_details");
          sessionStorage.removeItem("examEnded");
          sessionStorage.removeItem("lastUpdatedIndex");
          sessionStorage.removeItem("isEarlyMovedSection");
          navigate(`/${Cookies.get("test_engine_project")}/login`);
        }
      }
      return;
    }

    const timer = setInterval(() => {
      setCountdown((prev) => prev - 1);
    }, 1000);

    return () => clearInterval(timer);
  }, [countdown]);

  useFetchQuestion({
    currentSrNo: decryptParams?.SrNo,
    language: decryptParams?.lang,
    imageSize: decryptParams?.img,
    questionsAndOptions,
    decryptParams,
    projectDetails,
    handleEncodeJson,
    EncryptObjectFunction,
    isNavigate: false,
  });

  return (
    <>
      <Grid container
        sx={{
          background: "#fff",
          height: "100%",
          overflowX: "hidden",
        }}>

        <Grid item
          xs={12} md={9} lg={9}
          sx={{ background: "#fff", position: "relative" , height:"100%"}}
          pt={2}   // padding-top
          pr={2}   // padding-right
          pb={0}   // padding-bottom
          pl={2}
          minHeight="20vh"
        >
          <Typography
            sx={{
              fontSize: "20px",
              color: "rgba(63, 65, 209, 1)",
              fontWeight: "bold",
              textAlign: "Left",
            }}
          >
            Exam Summary
          </Typography>
          {Object.entries(data).map(([section, questions], index) => {
            return (
              <Box key={section} sx={{ mb: 2, mt: 1 }}>
                {isSection && (
                  <Box
                    p={1}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      alignItems: "center",
                      mb: 1,
                      backgroundColor: "rgba(240, 240, 251, 1)",
                      height: "50px",
                      borderRadius: "8px",
                    }}
                  >
                    <Typography
                      sx={{
                        color: "rgba(63, 65, 209, 1)",
                        fontSize: "14px",
                        fontWeight: "bold",
                      }}
                    >
                      {section}
                    </Typography>
                    {/* <Typography variant="body2">
                      {index < currentSectionIndex && (
                        <p>Time's up for this section!</p>
                      )}
                      {index === currentSectionIndex && (
                        <p>Time Remaining : {formatTime(remainingTime)}</p>
                      )}
                      {index > currentSectionIndex && (
                        <p>This section is locked</p>
                      )}
                    </Typography> */}
                  </Box>
                )}
                <Grid
                // sx={{
                //   height: "290px",
                //   overflowY: "scroll",
                //   paddingRight: "8px",
                //   "&::-webkit-scrollbar": {
                //     width: "8px",
                //   },
                //   "&::-webkit-scrollbar-track": {
                //     background: "#e0e0e0",
                //     borderRadius: "10px",
                //   },
                //   "&::-webkit-scrollbar-thumb": {
                //     background: "blue",
                //     borderRadius: "10px",
                //     border: "2px solid #e0e0e0",
                //     height: "10px",
                //     paddingBottom: "12px",
                //   },
                //   "&::-webkit-scrollbar-thumb:hover": {
                //     background: "darkblue",
                //   },
                // }}
                >
                  <Box
                    sx={{
                      display: "grid",
                      gridTemplateColumns: {
                        xs: "repeat(auto-fill, minmax(50px, 1fr))",
                        sm: "repeat(auto-fill, minmax(50px, 1fr))",
                        md: "repeat(12, 1fr)",
                        lg: "repeat(25, 1fr)",
                      },
                      gap: 1,
                      justifyItems: "center",
                    }}

                  >
                    {questions?.map((obj) => {
                      // const isCurrentQuestion =
                      //   currentSrNo === parseInt(obj.question_number);

                      const baseStyles = getQuestionStyle(
                        obj.status,
                        null,
                        obj.question_number,
                        visitedQuestions
                      );

                      return (
                        <Box
                          key={obj.question_number}
                          // onClick={() => {
                          //   if (!isSection) {
                          //     handleQuestionNavigation(obj);
                          //     handleAuditLog("", "", obj.question_number);
                          //   } else if (index === currentSectionIndex) {
                          //     handleQuestionNavigation(obj);
                          //     handleAuditLog("", "", obj.question_number);
                          //   }
                          // }}
                          sx={{
                            ...baseStyles,
                            aspectRatio: "1/1",
                            width: { xs: "30px", md: "26px" },
                            height: { xs: "30px", md: "26px" },
                            top: "4.59px",
                            left: "4.59px",
                            gap: "0px",
                            color: "#000",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            fontSize: "14px",
                            // cursor:'pointer',
                            // cursor: isSection
                            //   ? index === currentSectionIndex
                            //     ? "pointer"
                            //     : "not-allowed"
                            //   : "pointer",
                            // opacity: isSection
                            //   ? index === currentSectionIndex
                            //     ? 1
                            //     : 0.5
                            //   : 1,
                            position: "relative",
                            // "&:hover": {
                            //   transform: isCurrentQuestion
                            //     ? "none"
                            //     : "scale(1.05)",
                            //   transition: "transform 0.2s ease-in-out",
                            // },
                          }}
                        >
                          {obj.question_number}
                          {obj.status === "answered_and_marked" &&
                            (
                              <Box
                                component="img"
                                alt="check"
                                src={tickImage}
                                sx={{
                                  position: "absolute",
                                  bottom: -1,
                                  right: -4,
                                  height: "13px",
                                  width: "auto",
                                }}
                              />
                            )}
                        </Box>
                      );
                    })}
                  </Box>
                </Grid>
              </Box>
            );
          })}

          <Grid
          sx={{
          display: "flex",
          flexDirection: { xs: "column", sm: "row" },
          // 🔥 key fix
          alignItems: { xs: "stretch", sm: "center" },

          marginTop: { xs: "5rem", md: "2px" },
          paddingBottom:"1rem",
          backgroundColor: "#fff",
          gap: "12px",
          width: "100%",
          }}  
      >
    {!isAutologout && !isExamEnded && (
    <SecondaryButton
      variant="outlined"
      onClick={handleResumeExam}
      sx={{
        borderRadius: "24px",
        height: "40px",
        px: 3,
        py: 2,

        // 🔥 responsive width
        width: { xs: "100%", sm: "auto" },

        textTransform: "none",
        fontWeight: "600",
        whiteSpace: "nowrap",
      }}
    >
      Resume exam
    </SecondaryButton>
  )}

  <Button
    variant="contained"
    onClick={handleSubmit}
    sx={{
      borderRadius: "24px",
      height: "30px",
      px: 3,
      width: { xs: "100%", sm: "auto" },
      backgroundColor: "#E598AC",
      color: "#000",
      fontWeight: "600",
      textTransform: "none",
      "&:hover": {
        backgroundColor: "#E598AC",
      },
    }}
  >
    {isMock ? "Submit Exam" : "Submit"}
  </Button>
</Grid>

        </Grid>
        <Grid item
          xs={12}
          md={3}
          lg={3}
          sx={{ // 🔥 desktop only
            backgroundColor: "#F0F0FB",
            height: "auto",
          }}
        >
          <Box
            sx={{
              position: "fixed",
              top: "32px" ,
              right: "5px",
              transform:"translateY(-50%)",
              zIndex: 1300,
              borderRadius: "50%",
              width: "26px",
              height: "26px",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              backgroundColor: "#3F41D1",
              
            display: {
              xs: "flex",  // ✅ mobile
              md: "none",  // ❌ desktop
              },
              }} 
            > 
            {!close ? (
              <MdChevronRight color="white" size={20} onClick={handleClose}/>
            ) : (
              <MdChevronLeft color="white" size={20} onClick={handleClose} />
            )}

          </Box>
          {!close && (
            <Grid
              item
              xs={12}
              md={11}
              p={2}
              sx={{
                position: isMobile ? "fixed" : "relative",
                top: 0,
                right: 0,
                height: isMobile ? "100vh" : "auto",
                width: isMobile ? "85%" : "100%",
                backgroundColor: "#F0F0FB",
                zIndex: 1200,
                transform: isMobile && close ? "translateX(100%)" : "translateX(0)",
                transition: "transform 0.3s ease-in-out",
              }}
            >

              <Grid
                sx={{
                  backgroundColor: "rgba(240, 240, 251, 1)",
                  height: "32px",
                  borderRadius: "8px",
                  display: "flex",
                  justifyContent: "center"
                }}
                p={1}
              >
                <Typography
                  sx={{
                    color: "rgba(63, 65, 209, 1)",
                    fontSize: "14px",
                    fontWeight: "bold",
                  }}
                >
                  Summary
                </Typography>
              </Grid>
              <Grid
                container
                sx={{ display: "flex", flexDirection: "column", rowGap: "12px" }}
                p={2}
              >
                {statusConfigs.map((config) => (
                  <Box
                    key={config.key}
                    sx={{
                      display: "flex",
                      justifyContent: "space-between",
                      transform: "translateZ(0)",
                      backfaceVisibility: "hidden",
                      perspective: "1000px",
                    }}
                  >
                    <Typography sx={{ fontSize: "14px" }}>
                      {config.label}
                    </Typography>
                    <Box
                      sx={{
                        ...config.style,
                        color: "#000",
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        fontSize: "14px",
                        padding: '15px'
                      }}
                    >
                      {getStatusCount(config.key)}
                      {config.key === "answered_and_marked" && (
                        <Box
                          component="img"
                          alt="check"
                          src={tickImage}
                          sx={{
                            position: "absolute",
                            bottom: -1,
                            right: -4,
                            height: "13px",
                            width: "auto",
                          }}
                        />
                      )}
                    </Box>
                  </Box>
                ))}
              </Grid>


            </Grid>)}

        </Grid>

      </Grid>
      <SubmitModal type={"confirm"} heartBeat={heartBeat} encryptParams={encryptParams} />
    </>
  );
}
